import {
    ONBOARDING_FETCH_START,
    ONBOARDING_FETCH_SUCCESS,
    ONBOARDING_FETCH_FAILURE,
    ONBOARDING_MARK_STEP_LOCAL,
    ONBOARDING_MARK_WELCOME_SEEN,
    ONBOARDING_DISMISS_ALL_LOCAL,
    ONBOARDING_OPEN_WELCOME_MODAL,
    ONBOARDING_CLOSE_WELCOME_MODAL,
    ONBOARDING_START_TOUR,
    ONBOARDING_END_TOUR,
    ONBOARDING_SET_TOUR_STEP_INDEX,
    ONBOARDING_OPEN_CHECKLIST,
    ONBOARDING_CLOSE_CHECKLIST,
    ONBOARDING_RESET,
} from '../actions/onboarding';

const initialState = {
    loading: false,
    loaded: false,
    error: null,
    welcomeSeen: null,
    audience: '',
    totalSteps: 0,
    completedSteps: 0,
    progressPercent: 0,
    allCompleted: false,
    steps: [],
    demoSeedRefs: {
        chamadoNovoId: null,
        chamadoEmAndamentoId: null,
        chamadoEncerradoId: null,
        organizacaoId: null,
        timeId: null,
    },
    isWelcomeModalOpen: false,
    isChecklistOpen: false,
    activeTourId: null,
    currentTourStepIndex: 0,
};

export default function onboarding(state = initialState, action) {
    switch (action.type) {
        case ONBOARDING_FETCH_START:
            return { ...state, loading: true, error: null };

        case ONBOARDING_FETCH_SUCCESS: {
            const p = action.payload || {};
            return {
                ...state,
                loading: false,
                loaded: true,
                error: null,
                welcomeSeen: p.welcomeSeen ?? p.welcomeseen ?? null,
                audience: p.audience ?? '',
                totalSteps: p.totalSteps ?? 0,
                completedSteps: p.completedSteps ?? 0,
                progressPercent: p.progressPercent ?? 0,
                allCompleted: p.allCompleted ?? false,
                steps: Array.isArray(p.steps) ? p.steps : [],
                demoSeedRefs: p.demoSeedRefs || initialState.demoSeedRefs,
            };
        }

        case ONBOARDING_FETCH_FAILURE:
            return { ...state, loading: false, error: action.error };

        case ONBOARDING_MARK_STEP_LOCAL: {
            const { stepId, completedAt, allStepsCompleted } = action;
            const updatedSteps = state.steps.map((s) => {
                if (s.stepId === stepId && !s.completed) {
                    return { ...s, completed: true, completedAt };
                }
                return s;
            });
            const completedCount = updatedSteps.filter((s) => s.completed).length;
            return {
                ...state,
                steps: updatedSteps,
                completedSteps: completedCount,
                progressPercent: state.totalSteps === 0
                    ? 0
                    : Math.round((completedCount * 100) / state.totalSteps),
                allCompleted: allStepsCompleted ?? completedCount === state.totalSteps,
            };
        }

        case ONBOARDING_MARK_WELCOME_SEEN:
            return { ...state, welcomeSeen: true, isWelcomeModalOpen: false };

        case ONBOARDING_DISMISS_ALL_LOCAL: {
            const completedAt = new Date().toISOString();
            const updatedSteps = state.steps.map((s) => ({
                ...s,
                completed: true,
                completedAt: s.completedAt || completedAt,
            }));
            return {
                ...state,
                steps: updatedSteps,
                completedSteps: updatedSteps.length,
                progressPercent: 100,
                allCompleted: true,
                isChecklistOpen: false,
                activeTourId: null,
                currentTourStepIndex: 0,
            };
        }

        case ONBOARDING_OPEN_WELCOME_MODAL:
            return { ...state, isWelcomeModalOpen: true };

        case ONBOARDING_CLOSE_WELCOME_MODAL:
            return { ...state, isWelcomeModalOpen: false };

        case ONBOARDING_START_TOUR:
            return { ...state, activeTourId: action.tourId, currentTourStepIndex: 0 };

        case ONBOARDING_END_TOUR:
            return { ...state, activeTourId: null, currentTourStepIndex: 0 };

        case ONBOARDING_SET_TOUR_STEP_INDEX:
            return { ...state, currentTourStepIndex: action.index };

        case ONBOARDING_OPEN_CHECKLIST:
            return { ...state, isChecklistOpen: true };

        case ONBOARDING_CLOSE_CHECKLIST:
            return { ...state, isChecklistOpen: false };

        case ONBOARDING_RESET:
            return initialState;

        default:
            return state;
    }
}
